<template>
  <div class="left">
    <!--    搜索框-->
    <div class="search">
      <el-input placeholder="输入充电桩名称以搜索" suffix-icon="el-icon-search"></el-input>
    </div>
    <div class="list">
      <div class="list_title">充电桩列表</div>
      <div class="list_box">
        <div class="list_box_item"
             v-for="(item1, index1) in list"
             :key="item1.id"
        >
          <div class="list_box_item_title">{{ item1.name }}</div>
          <div
              :class="isSelectId === item2.id ? 'list_box_item_child list_box_item_child_active' : 'list_box_item_child'"
              @click="handleListItem(item2, item1)"
              v-for="(item2, index2) in item1.children"
              :key="item2.id">
            <img :src="`${isSelectId === item2.id ? item2.img_a : item2.img}`" alt="">
            {{ item2.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "list",
  props: ["list", "isSelectId", "detail"],
  methods: {
    handleListItem(item2, item1) {
      this.$emit('update:isSelectId', item2.id)
      this.$emit('update:detail', {...item2, parent: item1.name})
    }
  }
}
</script>

<style scoped lang="less">
.list {
  margin-top: 22rem;
  font-size: 14rem;

  .list_title {
    margin-bottom: 15rem;
  }

  .list_box {
    .list_box_item {
      .list_box_item_title {
        background-color: #F2F2F2;
        height: 40rem;
        line-height: 40rem;
        border-radius: 4rem;
        padding: 0 15rem;
        cursor: pointer;
      }

      .list_box_item_child {
        height: 30rem;
        line-height: 30rem;
        margin: 8rem 0;
        padding-left: 15rem;
        cursor: pointer;

        img {
          width: 7rem;
          height: 14rem;
        }
      }

      .list_box_item_child_active {
        background-color: rgba(13, 148, 255, .07) !important;
        color: #0d94ff;
      }
    }
  }
}

</style>